import React from 'react';

export default function AccessDenied() {
    return <div>AccessDenied</div>;
}
